import selectors from '../../rootSelectors';
import DNOServiceClient from '../clients/DNOServiceClient';
import {
    RCT, ACCURACY, FLUENCY, COMPREHENSION, DAZE, TRO, VOCAB, SPELLING, LN, TRC, WR, LC,
} from '../../constants/measure';
import { goToQuestion, goToPassage, goToBookStart, goToReading, goToInstructions } from '../navigation/navigationActions';
import { setIsReadyScriptPlayed } from '../../rct/rctActions';
import { STATUS } from '../../constants/result';
import * as page from '../../constants/assessmentItemType';
import VocaboServiceClient from '../clients/VocaboServiceClient';
import { showHelpPopup } from '../screen/screenActions';


const resumeRCTAccuracy = (nextItem) => (dispatch) => {
    dispatch(goToQuestion(RCT, ACCURACY, nextItem + 1));
};

const resumeRCTFluency = (nextItem) => (dispatch) => {
    dispatch(goToPassage(RCT, FLUENCY, nextItem + 1));
};

const resumeRCTComprehension = (nextItem) => (dispatch) => {
    dispatch(setIsReadyScriptPlayed(true));
    dispatch(goToPassage(RCT, COMPREHENSION, nextItem + 1));
};

const resumeDaze = () => (dispatch) => {
    dispatch(goToPassage(DAZE));
};

const resumeTRC = (nextItem, state) => (dispatch) => {
    const hasUnscoredUntranscribableResult = selectors.getHasUnscoredUntranscribableResult(state);
    const hasUnscoredUnknownErrorResult = selectors.getHasUnscoredUnknownErrorResult(state);
    if (hasUnscoredUnknownErrorResult || hasUnscoredUntranscribableResult) {
        dispatch(showHelpPopup());
        return;
    }
    if (nextItem === page.BOOK) {
        dispatch(goToBookStart(TRC));
    } else if (nextItem === page.COMPREHENSION) {
        dispatch(goToQuestion(TRC, null, 1));
    } else if (nextItem === page.INSTRUCTIONS) {
        dispatch(goToInstructions(TRC));
    }
};

const resumeLC = nextItem => dispatch => {
    if (nextItem === page.READING) dispatch(goToReading(LC.ASSESSMENT));
    if (nextItem === page.COMPREHENSION) dispatch(goToQuestion(LC.ASSESSMENT, null, 1));
};

const resumeLN = (nextItem) => (dispatch) => {
    dispatch(goToQuestion(LN.ASSESSMENT, null, nextItem));
};

const resumeVocab = (measure, state) => {
    const nextItem = selectors.getNextResultItem(state, { measure, isComplete: false });

    return (dispatch) => {
        dispatch(goToQuestion(VOCAB.ASSESSMENT, VOCAB[measure], nextItem));
    };
};

const resumeSpelling = (nextItem) => (dispatch) => {
    dispatch(goToQuestion(SPELLING.ASSESSMENT, null, nextItem));
};

const resumeWordReading = (measure, state) => (dispatch) => {
    const nextItem = selectors.getNextResultItem(state, { measure: WR.MEASURE, isComplete: false });

    return dispatch(goToQuestion(WR.KEY, null, nextItem));
};

const resumeAssessmentByMeasure = {
    [DNOServiceClient.CLIENT_TO_SERVER_MEASURE_NAME[LN.NAME]](measure, measureType, state) {
        const nextItem = selectors.getNextResultItem(state, { measure, isComplete: false });
        return (dispatch) => { dispatch(resumeLN(nextItem)); };
    },
    [DNOServiceClient.CLIENT_TO_SERVER_MEASURE_NAME[RCT]](measure, measureType, state) {
        if (measureType === ACCURACY) {
            const nextItem = selectors.getNextResultItem(state,
                { measure, measureType: ACCURACY, isComplete: false });
            return (dispatch) => { dispatch(resumeRCTAccuracy(nextItem)); };
        }
        if (measureType === COMPREHENSION) {
            const nextFluencyPassage = selectors.getNextResultItem(state,
                { measure, measureType: FLUENCY, isComplete: false });
            const nextCompPassage = selectors.getNextResultItem(state,
                { measure, measureType: COMPREHENSION, isComplete: false });
            if (nextFluencyPassage !== undefined && (
                nextCompPassage === undefined || nextCompPassage >= nextFluencyPassage)) {
                return (dispatch) => { dispatch(resumeRCTFluency(nextFluencyPassage)); };
            }
            return (dispatch) => { dispatch(resumeRCTComprehension(nextCompPassage)); };
        }
        return undefined;
    },

    [DNOServiceClient.CLIENT_TO_SERVER_MEASURE_NAME[DAZE]]() {
        return (dispatch) => { dispatch(resumeDaze()); };
    },

    [TRO.MEASURE](measure, measureType, state) {
        const nextItem = selectors.getNextResultItem(state,
            { measure: TRO.MEASURE, isComplete: false });
        return (dispatch) => { dispatch(resumeTRC(nextItem, state)); };
    },

    [LC.MEASURE](measure, measureType, state) {
        const nextItem = selectors.getNextResultItem(state,
            { measure: LC.MEASURE, isComplete: false });
        return (dispatch) => { dispatch(resumeLC(nextItem)); };
    },

    [WR.MEASURE](measure, measureType, state) {
        return (dispatch) => {
            dispatch(resumeWordReading(measure, state));
        };
    },

    [VocaboServiceClient.MEASURES.TQVM](measure, measureType, state) {
        return (dispatch) => {
            dispatch(resumeVocab(measure, state));
        };
    },

    [VocaboServiceClient.MEASURES.FITB](measure, measureType, state) {
        return (dispatch) => {
            dispatch(resumeVocab(measure, state));
        };
    },

    [VocaboServiceClient.MEASURES.BD](measure, measureType, state) {
        return (dispatch) => {
            dispatch(resumeVocab(measure, state));
        };
    },

    [SPELLING.MEASURE_API_KEY](measure, measureType, state) {
        const nextItem = selectors.getNextResultItem(state,
            { measure, isComplete: false });
        return (dispatch) => { dispatch(resumeSpelling(nextItem)); };
    },
};

/* eslint-disable-next-line import/prefer-default-export */
export const resumeAssessment = ({ measure, measureType, status }) => (dispatch, getStore) => {
    if (status !== STATUS.IN_PROGRESS) return;
    const state = getStore();
    dispatch(resumeAssessmentByMeasure[measure](measure, measureType, state));
};
